/**
 * Liste de référence des pays supportés.
 * Miroir de la constante COUNTRIES du BO
 * (bo/src/users/components/users/constants/users.constants.js).
 *
 * Seuls les pays dont l'ID figure dans `deliveryCountriesIds`
 * (config app) seront proposés à l'utilisateur.
 */
export interface Country {
  countryId: number;
  countryLib: string;
  countryCode: string;
}

export const COUNTRIES: Country[] = [
  { countryId: 5, countryLib: 'DEUTSCHLAND', countryCode: 'DE' },
  { countryId: 17, countryLib: 'ÖSTERREICH', countryCode: 'AT' },
  { countryId: 24, countryLib: 'BELGIUM', countryCode: 'BE' },
  { countryId: 59, countryLib: 'ESPAÑA', countryCode: 'ES' },
  { countryId: 67, countryLib: 'FRANCE', countryCode: 'FR' },
  { countryId: 143, countryLib: 'MONACO', countryCode: 'MC' },
  { countryId: 112, countryLib: 'ITALIA', countryCode: 'IT' },
  { countryId: 129, countryLib: 'LUXEMBOURG', countryCode: 'LU' },
  { countryId: 167, countryLib: 'THE NETHERLANDS', countryCode: 'NL' },
  { countryId: 174, countryLib: 'PORTUGAL', countryCode: 'PT' },
];

/**
 * Construit la liste des pays autorisés en croisant la constante
 * COUNTRIES (référentiel front) avec deliveryCountriesIds (config API).
 */
export function buildCountryOptions(
  deliveryCountriesIds: string | undefined,
): { value: number; text: string }[] {
  if (!deliveryCountriesIds) return [];

  const ids = deliveryCountriesIds
    .split(',')
    .map((id: string) => Number(id.trim()))
    .filter((id: number) => !isNaN(id));

  const options: { value: number; text: string }[] = [];

  ids.forEach((id: number) => {
    const country: Country | undefined = COUNTRIES.find(
      (c) => c.countryId === id,
    );
    if (country) {
      options.push({ value: country.countryId, text: country.countryLib });
    }
  });

  return options;
}
